import { CommonColumnsType } from '@op/types/table';
import app_store from '@op/assets/svg/channel/app_store.svg';
import google_play from '@op/assets/svg/channel/google_play.svg';
import hatchet from '@op/assets/svg/hatchet.svg';
import google_trends from '@op/assets/imgs/icon-google.png';

export const OPINIONS_OVERVIEW: CommonColumnsType[] = [
  {
    header: 'Mentions',
    key: 'mentions',
    progress: true,
  },
  {
    header: 'Brand Health',
    key: 'brand_health',
    progress: true,
  },
  {
    header: 'Sentiment',
    key: 'sentiment',
    progress: true,
  },
  {
    header: 'Non Negative%',
    key: 'non_negative',
    progress: true,
  },
];

export const GOOGLEPLAY_GAME_STORE: CommonColumnsType[] = [
  {
    header: 'Lifetime Rating',
    key: 'google_play_lifetime_rating',
    progress: true,
    icon: google_play,
  },
  {
    header: 'Lifetime Review',
    key: 'google_play_lifetime_reviews',
    progress: true,
    icon: google_play,
  },
  {
    header: 'Lifetime Negative%',
    key: 'google_play_lifetime_negative',
    progress: true,
    icon: google_play,
  },
  {
    header: 'Filtered Rating',
    key: 'google_play_filtered_rating',
    progress: true,
    icon: google_play,
  },
  {
    header: 'Filtered Reviews',
    key: 'google_play_filtered_reviews',
    progress: true,
  },
  {
    header: 'Filtered Negative%',
    key: 'google_play_filtered_negative',
    progress: true,
    icon: google_play,
  },
];

export const APPSTORE_GAME_STORE: CommonColumnsType[] = [
  {
    header: 'Lifetime Rating',
    key: 'app_store_lifetime_rating',
    progress: true,
    icon: app_store,
  },
  {
    header: 'Lifetime Review',
    key: 'app_store_lifetime_reviews',
    progress: true,
    icon: app_store,
  },
  {
    header: 'Lifetime Negative%',
    key: 'app_store_lifetime_negative',
    progress: true,
    icon: app_store,
  },
  {
    header: 'Filtered Rating',
    key: 'app_store_filtered_rating',
    progress: true,
    icon: app_store,
  },
  {
    header: 'Filtered Reviews',
    key: 'app_store_filtered_reviews',
    progress: true,
    icon: app_store,
  },
  {
    header: 'Filtered Negative%',
    key: 'app_store_filtered_negative',
    progress: true,
    icon: app_store,
  },
];

export const COMMUNITY: CommonColumnsType[] = [
  {
    header: 'Engagement',
    key: 'engagement',
    progress: true,
  },
  {
    header: 'Likes',
    key: 'likes',
    progress: true,
  },
  {
    header: 'Comments',
    key: 'comments',
    progress: true,
  },
  {
    header: 'Shares',
    key: 'shares',
    progress: true,
  },
  {
    header: 'Potential Impressions',
    key: 'impression',
    progress: true,
  },
  {
    header: 'Publications',
    key: 'publications',
    progress: true,
  },
  {
    header: 'Number of Creators',
    key: 'creators',
    progress: true,
  },
  {
    header: 'Views',
    key: 'views',
    progress: true,
  },
  {
    header: 'Hours Watched',
    key: 'hours_watched',
    progress: true,
    icon: hatchet,
  },
  {
    header: 'Peak CCV',
    key: 'peak_ccv',
    progress: true,
    icon: hatchet,
  },
  {
    header: 'Avg CCV',
    key: 'avg_ccv',
    progress: true,
    icon: hatchet,
  },
  {
    header: 'Airtime (hours)',
    key: 'airtime',
    progress: true,
    icon: hatchet,
  },
];

export const OPERATION_METRICS: CommonColumnsType[] = [
  {
    header: 'DAU',
    key: 'dau',
    progress: true,
  },
  {
    header: 'Revenue',
    key: 'revenue',
    progress: true,
  },
  {
    header: 'Download',
    key: 'download',
    progress: true,
  },
];

export const PR: CommonColumnsType[] = [
  {
    header: 'News',
    key: 'news',
    progress: true,
  },
  {
    header: 'Google Trends',
    key: 'google_trends',
    progress: true,
    icon: google_trends,
  },
];

export const METRICS_COLUMNS = [
  ...OPINIONS_OVERVIEW,
  ...GOOGLEPLAY_GAME_STORE,
  ...APPSTORE_GAME_STORE,
  ...COMMUNITY,
  ...OPERATION_METRICS,
  ...PR,
];

export const COMPARE_COLORS = [
  '#5086F3',
  '#69D19C',
  '#6E7794',
  '#F5D242',
  '#7F6FF1',
  '#5EC8F1',
  '#AD53D4',
  '#F19E55',
  '#5EC8F1',
  '#F17C86',
];

export const METRICS_KEY_WITH_ZERO = [
  'mentions',
  'steam_added_reviews',
  'google_play_filtered_reviews',
  'app_store_filtered_reviews',
  'news',
  'exclude_discord_comments',
  'creators',
];

export const METRICS_KEY_ZERO_NO_RATIO = [
  'sentiment',
  'google_play_lifetime_rating',
  'google_play_lifetime_reviews',
  'google_play_lifetime_negative',
  'google_play_filtered_rating',
  'app_store_lifetime_rating',
  'app_store_lifetime_reviews',
  'app_store_lifetime_negative',
  'app_store_filtered_rating',
  'steam_all_reviews',
  'steam_all_reviews_positive',
  'steam_recent_reviews',
  'steam_recent_reviews_positive',
  'metacritic_score',
  'metacritic_user_score',
  'metacritic_user_reviews',
  'opencritic_top_critic_average',
  'opencritic_recommended',
  'hours_watched',
  'peak_ccv',
  'avg_ccv',
  'airtime',
  'google_trends',
  'dau',
  'revenue',
  'download',
  'pcu',
  'digital_revenue',
  'units',
];
